import { UiDepartment } from "./UI-data.model "

export interface User {
  /* Unique incremental ID */
  repId: number,

  country: string,

  salesIqUserId: string,

  /*
   * profile name
   */
  username: string,

  /* maximum day limit without logging in */
  expirationOffset: number,

  /* store sign-in */
  gpsEnabled: boolean,

  /* maximum login reached */
  //locked: boolean,

  /* disabled user */
  //inactive: boolean,

  /* 自营 | 代理 | 定向 */
  //salesmanType: Text,

  /* customer, supervisor, salesrep, */
  role: EUserRole,

  /* contact detail */
  mobile: string,
  telephone: string,
  wechat: string,
  email: string,
  address1: string,
  address2: string,

  /* display actual qty or assigned qty */
  actualQtyDisplay: boolean,

  /* maximum qty to display */
  actualMaxQtyDisplay: number,

  /* The amount to check if 2nd approval is mandatory or not */
  managerApprovalAmt: number,

  /* boolean to check the price is editable (only for salesrep and supervisor) */
  editPrice: number

  /* boolean to display the best before day (bbd) */
  showBBD: boolean

  /* boolean to check user require gps or not */
  usegps: boolean

  /* if distance over warning, will pop up alarn message */
  distancewarning: number

  /* if distance over error, will lock the button */
  distanceerror: number

  /** will use to control the cost and margin display in soup 11/07/2022 Eric Z */
  costVisible: boolean
}

export interface OmisUser {
  id: number
  name: string
  companyId: number
  companyName: string
  departmentId: number
  departmentName: string
  roleId: number
  roleName: string
  account: string
  mobile: string
  email: string
  salesiquserid: string
  lock: boolean
  active: boolean
  dashboardDesigner: boolean
}

export interface UserCredential {
  jwtToken: string
}

/**
 * for customer gps and custoemr visit use
 * will record user latitude and longitude and the boolean to record salesrep will resite
 */
export interface UserLocation {
  lat: number,
  lng: number,
}

/**
 * Role enum.
 */
export enum EUserRole {
  CUSTOMER = 'Customer',
  SALESREP = 'SalesRep',
  SUPERVISOR = 'Supervisor',
}

export interface customerVisit {
  isVisit: boolean
  visitTime: number
}

export interface Preference {
  preferences: UiDepartment[]
}

export interface UserAuth {
  id?: number,
  moduleId: number,
  userId: number,
  permission: number,
  preference: boolean,
  moduleName:string,
  userName:string //idk what is this 28/04/2023 by ericz
}

export interface DepartmentDetail {
  id: number,
  name: string
}

export interface CompanyDetail {
  id: number,
  name: string
}

export interface ModuleDetail {
  id: number
  name: string
  sideBarOptionId: number,
  path: string,
  tileColor: string
}

export interface DefaultModuleDetail {
  index: number
  departmentId: number
  departmentName:string
  moduleId: number
  moduleName:string
  permission: number
}

export interface roleDetail {
  id: number
  name: EUserRole
}

export enum EUserRole {
  USER = 'User',
  ADMIN = 'Admin'
}

export interface SideBarOptionDetail {
  id: number
  name: string
  iconName: string
}

/**
 * will use in the static data api
 */
export interface GetStaticBody {
  departmentList: DepartmentDetail[],
  companyList: CompanyDetail[],
  moduleList: ModuleDetail[],
  defaultModuleList: DefaultModuleDetail[],
  roleList: roleDetail[],
  sideBarOptList: SideBarOptionDetail[]
}

export interface SignInCredential {
  username:string
  password:string,
}

export interface SignInResponse {
  token:string
  routeId:number
  azureToken:string
  azureBaseUrl:string
}

export interface TimeSlotUser {
  id: number,
  username: string,
  displayName: string,
  lastLogin: string,
  warehouseCode: string,
  active: boolean,
  email: string,
  referenceCode: string,
}

export interface LoginResponse {
  token: string
}

